const DESKTOP_FALLBACK_URL =
    'https://www.amazon.es/gil/es/santander/wait?loanApplicationId=loan_id',
  IOS_NOT_DESKTOP_FALLBACK_URL = 'com.amazon.mobile.shopping://amazon.es/CloseInAppBrowser',
  ANDROID_NOT_DESKTOP_FALLBACK_URL =
    'com.amazon.mobile.shopping.thirdpartynavigation://amazon.es/CloseInAppBrowser';

export { ANDROID_NOT_DESKTOP_FALLBACK_URL, DESKTOP_FALLBACK_URL, IOS_NOT_DESKTOP_FALLBACK_URL };
